import ReactVisibilitySensor from "react-visibility-sensor";
import { useMobile } from "../../../../../../context/MobileContext";
import styles from "./style.module.scss";
import "./style.scss";

const FlowerCards = ({ cardsEnum }) => {
  const { isWidthMiddle } = useMobile();
  const renderCard = (item, index) => {
    return (
      <ReactVisibilitySensor
        key={index}
        offset={isWidthMiddle ? { top: 100, bottom: 100 } : null}
        intervalDelay={500}
      >
        {({ isVisible }) => {
          return (
            <div
              key={index}
              className={`card card-${index + 1}`}
              style={{
                backgroundImage: `url(${item.src})`,
              }}
            >
              {
                <div
                  className={isWidthMiddle ? (isVisible ? "text-container" : "") : "text-container"}
                >
                  {isWidthMiddle ? (
                    isVisible && (
                      <>
                        <div className="title">{item.title}</div>
                        <div className="content">{item.content}</div>
                      </>
                    )
                  ) : (
                    <>
                      <div className="title">{item.title}</div>
                      <div className="content">{item.content}</div>
                    </>
                  )}
                </div>
              }
            </div>
          );
        }}
      </ReactVisibilitySensor>
    );
  };

  return (
    <div className={`${styles.cardsContainer} flower-cards`}>
      {cardsEnum.map((item, index) => renderCard(item, index))}
    </div>
  );
};

export default FlowerCards;
